import { useContext } from 'react';

import { MeetClassificationFlatStateContext } from './MeetClassificationFlatContextProvider';

import MeetClassificationFlatData from './MeetClassificationFlatData';

const useMeetClassificationFlatData = () => {
  const [meetClassificationFlatState, setMeetClassificationFlatState] = useContext(MeetClassificationFlatStateContext);

  const getMeetClassificationFlat = (trackMedals, isOpenCompetition, trackCareerStats) => {
    MeetClassificationFlatData.getMeetClassificationFlat(trackMedals, isOpenCompetition, trackCareerStats, meetClassificationFlatState, setMeetClassificationFlatState);
  };

  return {
    meetClassificationFlatState, 
    setMeetClassificationFlatState,
    getMeetClassificationFlat
  };
};

export default useMeetClassificationFlatData;